module.exports = "/assets/ae18bfcf2597e3cdc4cec3a3577c643c.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/4W.png
// module id = 2178
// module chunks = 0